<template>
  <div class="h-box">
    <h2 class="global-title">{{ $t('mbs-select-history') }}</h2>
    <h3 class="h-txt">{{ $t('Recent-Account-Access') }}</h3>
    <div v-if="list && list.length > 0" class="h-content">
      <div v-for="(item, index) in list" :key="index" class="h-cell">
        <div class="pc">
          <img
            v-if="item.system && item.system === 'web'"
            src="~img/member/icon-pc.svg"
            alt="icon-pc"
          />
          <img v-else src="~img/member/icon-phone.svg" alt="icon-phone" />
          <p>{{ item.newStr }}</p>
          <p :class="{ 'now-txt': index === 0 }">
            {{ index === 0 ? $t('Active.Now') : item.dateStr }}
          </p>
        </div>
        <div class="mobile">
          <img
            v-if="item.system && item.system === 'web'"
            src="~img/member/icon-pc.svg"
            alt="icon-pc"
          />
          <img v-else src="~img/member/icon-phone.svg" alt="icon-phone" />
          <div class="mobile-wrapper">
            <p>{{ item.newStr }}</p>
            <p :class="{ 'now-txt': index === 0 }">
              {{ index === 0 ? $t('Active.Now') : item.dateStr }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import { formatDateEN, formatHHmm } from '@/utils';
import i18n from '@/i18n/index';

  export default {
    name: 'history',
    data() {
      return {
        i18n,
        list: [],
      };
    },
    mounted() {
      this.getHistoryList();
    },
    computed: {
      ...mapState(['userInfo']),
    },
    methods: {
      // 获取登录历史
      async getHistoryList() {
        this.$loading.show();
        const { userId, sessionId } = this.userInfo || {};
        const data = {
          lang: this.$i18n.locale,
          userId,
          sessionId,
        };
        try {
          const res = await this.$http.account.getHistoryList(data);
          if (res?.state === '11') {
            this.$loading.hide();
            if (res?.histories?.length > 0) {
              this.list = res.histories.map(v => {
                /* eslint-disable */
                const str = v.loginCity
                  ? v.loginCountry
                    ? `${v.loginCity}, ${v.loginCountry}`
                    : v.loginCity
                  : v.loginCountry;
                const newStr = str ? `${v.deviceName} • ${str}` : v.deviceName;
                const dateStr = v.loginTimestamp
                  ? `${formatDateEN(new Date(v.loginTimestamp))} ${i18n.global.t('at')} ${formatHHmm(
                      new Date(v.loginTimestamp),
                    )} (UTC)`
                  : '';
                return {
                  ...v,
                  newStr,
                  dateStr,
                };
              });
            } else {
              this.list = [];
            }
          }
        } catch (err) {
          console.error(err);
          this.$loading.hide();
        }
      },
    },
  };
</script>

<style scoped lang="scss">
  .h-box {
    @include global-title();

    .h-txt {
      margin-top: 32px;
      @include font(24px, 600);
      line-height: 32px;
      color: $color-blue;
    }

    .h-content {
      .h-cell {
        @include flex(row, center, space-between);
        padding: 12px 48px;
        margin-top: 24px;
        box-shadow: 0 0 16px rgba(0, 0, 0, 0.25);
        border-radius: 8px;

        .pc {
          width: 100%;
          display: flex;
          align-items: center;
          p {
            @include font(16px, 600);
            line-height: 20px;
            color: #54606c;
          }
          p:last-child {
            margin-left: auto;
          }
          img {
            margin-right: 35px;
          }
          div {
            @include flex(row, center, unset);

            img {
              width: 50px;
              height: 50px;
              margin-right: 24px;
            }

            p {
              @include font(18px, 600);
              line-height: 24px;
              color: $color-blue;
            }
          }

          .now-txt {
            color: $color-glod;
          }
        }

        .mobile {
          display: none;
        }
      }
    }
  }

  @media screen and (max-width: 1024px) {
    .h-box {
      .global-title {
        @include font(18px, 600);
        line-height: 40px;
        margin-bottom: 12px;
        padding: 0;
      }

      .h-txt {
        @include font(16px, 600);
        line-height: 22px;
        padding-top: 16px;
        margin: 0;
      }

      .h-content {
        .h-cell {
          padding-left: 3%;
          padding-right: 3%;
          display: block;

          .pc {
            display: none;
          }

          .mobile {
            display: flex;
            align-items: center;

            img {
              background-size: 30px 30px;
              width: 30px;
              height: 30px;
              padding-right: 10px;
            }

            .mobile-wrapper {
              display: flex;
              flex-direction: column;

              p {
                @include font(14px, 600);
                line-height: 19px;
                @include ellipsis();
              }

              p:nth-child(2) {
                @include font(14px, 700);
                padding-top: 8px;
              }
            }

            .now-txt {
              color: $color-glod;
            }
          }
        }
      }
    }
  }
</style>
